import { initializeApp, FirebaseApp } from 'firebase/app'
import { FIREBASE_CONFIG } from '../../../config'

const firebaseConfig = JSON.parse(FIREBASE_CONFIG as string)

export class FirebaseInstance {
  private static instance: FirebaseApp | null = null

  public static initialize(): FirebaseApp {
    if (!firebaseConfig.apiKey) {
      console.error('Firebase config is not set. Please set your Firebase configuration')
    }
    if (!FirebaseInstance.instance) {
      FirebaseInstance.instance = initializeApp(firebaseConfig)
    }
    return FirebaseInstance.instance
  }

  public static getInstance(): FirebaseApp {
    if (!FirebaseInstance.instance) {
      throw new Error('Firebase has not been initialized. Call initialize() first.')
    }
    return FirebaseInstance.instance
  }
}
